import { apiService } from './api';

export const userService = {
  getAll: async () => {
    try {
      const response = await apiService.get('/account/users');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch users');
    }
  },

  getById: async (id) => {
    try {
      const response = await apiService.get(`/account/user/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch user');
    }
  },

  create: async (userData) => {
    try {
      const response = await apiService.post('/account/user/create', userData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create user');
    }
  },

  update: async (id, userData) => {
    try {
      const response = await apiService.put(`/account/user/${id}`, userData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update user');
    }
  },

  delete: async (id) => {
    try {
      const response = await apiService.delete(`/account/user/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete user');
    }
  }
}; 